"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

class GitInfo extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, "RELEASE DATE:", ' ', process.env.RELEASE_DATE), /*#__PURE__*/_react.default.createElement("div", null, "BRANCH:", ' ', process.env.BRANCH));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({});

var _default = (0, _reactRedux.connect)(mapStateToProps)(GitInfo);

exports.default = _default;